import React, { createContext, useContext, useEffect, useState } from 'react';
import { listenToPlatformConfig } from '../services/firebase';
import {
  DEFAULT_PLATFORM,
  normalizePlatformConfig,
  setActivePlatformConfig,
} from '../utils/platformConfig';

const PlatformContext = createContext(null);

export const PlatformProvider = ({ children }) => {
  const [platformConfig, setPlatformConfig] = useState(() => normalizePlatformConfig(null));
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setActivePlatformConfig(null);
    return listenToPlatformConfig((data) => {
      const normalized = normalizePlatformConfig(data);
      setActivePlatformConfig(data);
      setPlatformConfig(normalized);
      setLoaded(true);
    });
  }, []);

  return (
    <PlatformContext.Provider value={{ platformConfig, platformLoaded: loaded }}>
      {children}
    </PlatformContext.Provider>
  );
};

export const usePlatform = () => {
  const ctx = useContext(PlatformContext);
  if (!ctx) {
    return {
      platformConfig: normalizePlatformConfig(null),
      platformLoaded: false,
    };
  }
  return ctx;
};

export { DEFAULT_PLATFORM };
